import usePopups from "@/stores/popupsStore"
import { Alert } from "vue-utils"

export function useVtsValidation() {
	const popups = usePopups()

	async function confirmReset(): Promise<boolean> {

		return await popups.confirm({
			confirmText: "Reset",
			content: () => (
				<Alert title={`Reset Log`}>
					Are you sure you want to reset the log?
				</Alert>
			),
		})
	}

	return {
		confirmReset,
	}
}
